import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from './../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';
import SeccionPageHeader from './../../Utils/SeccionPageHeader';
import CargandoSpinner from './../../Utils/CargandoSpinner';

export default function DiagnosticoRetorno(){
    const {token} = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    
    const [datosRetorno, setDatosRetorno] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatoretorno?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosRetorno(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionPersonas (row, verAtencionesPersona){
            return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.per_idpersona} row={row} />
        }
    const columns = [
        {
            name: 'Acciones',
            cell: row => verAtencionPersonas(row, verAtencionesPersona),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width:'2%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '3%'},
        { name: 'Fecha entrevista', selector: row => row.ret_fechaentrevista, sortable: true, width: '2%'},
        { name: 'Fecha visita', selector: row => row.ret_fechavisitadomiciliaria, sortable: true, width: '2%' },
        { name: 'Diligenciar el tipo de apoyo que se solicita', selector: row => row.tip_tipoapoyo, sortable: true, width: '2%' },
        { name: 'Motivos planteados por el grupo para retorno', selector: row => row.tipo_motivo, sortable: true, width: '2%' },
        { name: '¿Se entrega carta de voluntariedad?', selector: row => row.ret_redesvoluntariedad, sortable: true, width: '2%' },
        { name: 'En caso de no entregar carta de voluntariedad expresar por qué', selector: row => row.razon_no_voluntariedad, sortable: true, width: '2%' },
        { name: 'No. de personas del núcleo familiar que serían retornadas o reubicadas', selector: row => row.ret_nropersonas, sortable: true, width: '2%' },
        { name: 'Departamento', selector: row => row.dep_departamento, sortable: true, width: '2%' },
        { name: 'Municipio', selector: row => row.mun_municipio, sortable: true, width: '10%' },
        { name: 'Comuna o corregimiento para donde desea retornar o reubicarse la familia', selector: row => row.ret_corregimientopeticion, sortable: true, width: '10%' },
        { name: 'Barrio o vereda para donde desea retornar o reubicarse', selector: row => row.ret_veredabarriopeticion, sortable: true, width: '10%' },
        { name: 'Dirección', selector: row => row.ret_direccionpeticion, sortable: true, width: '10%' },
        { name: 'Teléfono', selector: row => row.ret_telefonopeticion, sortable: true, width: '10%' },
        { name: 'Tipo de entorno del lugar en donde desea retornar o reubicarse la familia', selector: row => row.tip_tipoentorno, sortable: true, width: '10%' },
        { name: '¿Algún miembro del grupo familiar es propietario(a) del bien donde la familia desea retornar o reubicarse?', selector: row => row.ret_viviendaintegrante, sortable: true, width: '10%' },
        { name: 'Tipo de bien inmueble en donde la familia desea retornar o reubicarse', selector: row => row.tip_tipobien, sortable: true, width: '10%' },
        { name: '¿Se tiene documentación que acredite la propiedad del bien inmueble?', selector: row => row.ret_documentacionvivienda, sortable: true, width: '10%' },
        { name: '¿Realizó proceso de protección del bien abandonado?', selector: row => row.ret_protegiobien, sortable: true, width: '10%' },
        { name: '¿Posee resolución de la protección del bien?', selector: row => row.ret_resolucionproteccion, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentra el techo de la vivienda', selector: row => row.EstadoTecho, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentran los pisos de la vivienda', selector: row => row.EstadoPisos, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentran los baños de la vivienda', selector: row => row.EstadoBanos, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentran las paredes de la vivienda', selector: row => row.EstadoParedes, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentra la cocina de la vivienda', selector: row => row.EstadoCocina, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con servicio de alcantarillado', selector: row => row.ret_servicioalcantarillado, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con pozo séptico', selector: row => row.ret_serviciopozoseptico, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con servicio de acueducto', selector: row => row.ret_servicioacueducto, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con servicio de energía', selector: row => row.ret_servicioenergia, sortable: true, width: '10%' },
        { name: 'Educación', selector: row => row.ret_educacion, sortable: true, width: '10%' },
        { name: 'Seguridad', selector: row => row.ret_redesconceptoseguridad, sortable: true, width: '10%' },
        { name: '¿Se construyó plan de vida para el proceso de retorno o reubicación?', selector: row => row.ret_redesplanvida, sortable: true, width: '10%' },
        { name: 'Explotación agrícola', selector: row => row.tipo_explotacion, sortable: true, width: '10%' },
        { name: 'Especies que le gustaría trabajar en su predio', selector: row => row.tipo_especies, sortable: true, width: '10%' },
        { name: 'Nro. de personas a transportar', selector: row => row.ret_redestransportepersonasnro, sortable: true, width: '10%' },
        { name: 'Costo aproximado transporte de personas', selector: row => row.ret_redestransportepersonascosto, sortable: true, width: '10%' },
        { name: 'Costo acarreo de enceres', selector: row => row.ret_redesacarreocosto, sortable: true, width: '10%' },
        { name: 'Objetos por llevar', selector: row => row.tipo_objetos, sortable: true, width: '10%' },
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoretorno?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_retorno.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Diagnostico retorno"
                idCabezaFamilia="1"
                url="/consultas/verdiagnosticos"
                nombreurl="Diagnosticos"
                nombreform="Retorno"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos/>
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosRetorno} nombre="DiagnosticoRetornos" exportarCSV={exportarCSV} />
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            {columns.map((col, idx) => (
                                                <th key={idx}>{col.name}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {datosRetorno.length === 0 ? (
                                            <tr>
                                                <td colSpan={columns.length} className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            datosRetorno.map((row, rIdx) => (
                                                <tr key={rIdx}>
                                                    {columns.map((col, cIdx) => {
                                                        // prefer cell renderer, fallback to selector function or string key
                                                        if (col.cell) return <td key={cIdx}>{col.cell(row)}</td>;
                                                        if (typeof col.selector === 'function') return <td key={cIdx}>{col.selector(row)}</td>;
                                                        return <td key={cIdx}>{row[col.selector]}</td>;
                                                    })}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>

                                {/* simple server-side pagination controls */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <label>Filas por página:</label>
                                        <select
                                            value={perPage}
                                            onChange={e => {
                                                const newPer = Number(e.target.value);
                                                handlePerRowsChange(newPer, 1); // go to first page with new page size
                                            }}
                                        >
                                            {[5,10,20,50,100].map(n => <option key={n} value={n}>{n}</option>)}
                                        </select>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <button
                                            className="btn btn-sm btn-secondary"
                                            onClick={() => { if (currentPage > 1) handlePageChange(currentPage - 1); }}
                                            disabled={currentPage <= 1 || Cargando}
                                        >
                                            Anterior
                                        </button>
                                        <span>Página {currentPage} de {Math.max(1, Math.ceil(totalRows / perPage) || 1)}</span>
                                        <button
                                            className="btn btn-sm btn-secondary"
                                            onClick={() => { if (currentPage < Math.ceil(totalRows / perPage)) handlePageChange(currentPage + 1); }}
                                            disabled={currentPage >= Math.ceil(totalRows / perPage) || Cargando}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}